export default __webpack_public_path__ + "static/project-slide-6-1640-765-e923b52e9d988214d29eeef1fcb8a927.webp";